import React from "react";
import CanvasAnimation from "../../Components/CanvasItems";

const Introduction = () => {
    return (
        <div className="doc_page_cont">
            <p className="doc_page_cont_title">Welcome to Erioon Devs</p>
            

            <p className="doc_page_cont_paragraph">
                <strong>Erioon</strong> is a high-performance, encrypted knowledge storage environment designed for AI and developer applications. 
                It allows you to store vast amounts of information securely while ensuring that your AI retrieves only what’s relevant, keeping context clean and operations efficient. 
                Built with a non-relational, API-first architecture, Erioon offers dynamic schemas, sharded collections, and ultra-fast operations. 
                With <strong>autoscale</strong>, you can expand storage and capacity effortlessly without configuring clusters, storage layers, or complex migration pipelines.
            </p>

            <p className="doc_page_cont_subtitle">The Erioon Flow</p>
            <p className="doc_page_cont_paragraph">
                Getting started with Erioon is fast and intuitive. Here’s the typical journey:
            </p>
            <ol className="list_cont_doc">
                <li>Register or log in to <a href="https://www.erioon.com" className="text-blue-400">erioon.com</a> and create a project.</li>
                <li>Add an IP in the Network section (see <a href="https://www.erioon.com/dev-docs/ip-network" className="text-blue-400">Network & IPs</a>).</li>
                <li>Generate your API credentials from the dashboard (see <a href="https://www.erioon.com/dev-docs/api-key" className="text-blue-400">API Keys</a>).</li>
            </ol>
        </div>
    );
};

export default Introduction;
